// extracted by mini-css-extract-plugin
module.exports = {"title":"styles-m__title__3fT_L","text":"styles-m__text__heE2m","rate-tag":"styles-m__rate-tag__1sDN3"};